<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h2" id="con"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><b>CONTENTS</b></span></span></p>
<p class="imagef"><img alt="" src="images/line.jpg"/></p>
<p class="toc_1" id="rpre"><a href="#/text/9780253049896_Preface"><span class="small">PREFACE</span></a></p>
<p class="toc_1" id="rack"><a href="#/text/9780253049896_Ack"><span class="small">ACKNOWLEDGMENTS</span></a></p>
<p class="toc_c" id="rch1"><a href="#/text/9780253049896_Chapter_1">1<span class="space_1"><b>PIONEER RAILROAD</b></span></a></p>
<p class="toc_c" id="rch2"><span href="#/text/9780253049896_Chapter_2" title="Link target outside of Sample">2<span class="space_1"><b>EXPANSION</b></span></span></p>
<p class="toc_c" id="rch3"><span href="#/text/9780253049896_Chapter_3" title="Link target outside of Sample">3<span class="space_1"><b>ROBBER BARONS</b></span></span></p>
<p class="toc_c" id="rch4"><span href="#/text/9780253049896_Chapter_4" title="Link target outside of Sample">4<span class="space_1"><b>ROUGH TRACKS</b></span></span></p>
<p class="toc_c" id="rch5"><span href="#/text/9780253049896_Chapter_5" title="Link target outside of Sample">5<span class="space_1"><b>FARRINGTON ERA</b></span></span></p>
<p class="toc_c" id="rch6"><span href="#/text/9780253049896_Chapter_6" title="Link target outside of Sample">6<span class="space_1"><b>SAVING THE ROCK</b></span></span></p>
<p class="toc_c" id="rch7"><span href="#/text/9780253049896_Chapter_7" title="Link target outside of Sample">7<span class="space_1"><b>LIQUIDATION AND LEGACY</b></span></span></p>
<p class="toc_1" id="rnot"><span href="#/text/9780253049896_Notes" title="Link target outside of Sample"><span class="small">NOTES</span></span></p>
<p class="toc_1" id="rind"><span href="#/text/9780253049896_Index" title="Link target outside of Sample"><span class="small">INDEX</span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253049896_Contents.vue?20208363